export const ArrowRightSmall: React.FC<any> = ({ className }) => {
  return (
    <div
      className={`${className} fill-[#BEBEBE]`}
      dangerouslySetInnerHTML={{
        __html: `
       <svg xmlns="http://www.w3.org/2000/svg" width="7" height="11" viewBox="0 0 7 11" fill="none">
        <path d="M0.855957 9.52344L5.85596 5.02344L0.855957 0.523438" stroke="inherit" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `,
      }}
    />
  );
};
